/* eslint-disable camelcase */
import { Instance, SnapshotOut, types } from "mobx-state-tree"
import { Fasting, Feed } from "../../database"
import { withEnvironment } from "../extensions/with-environment"
import { withRootStore } from "../extensions/with-root-store"
import { withBaseModel } from "../extensions/with-base-model";
import { BaseModelStoreProps } from "../base-model-store/base-model-store"
import SyncableModel from "../../database/SyncableModel";
import moment from "moment"
import JalaAnalytic from "../../utils/jala-analytic"

const FeedStoreProps = {
  ...BaseModelStoreProps,
}

/**
 * Model description here for TypeScript hints.
 */
export const FeedStoreModel = types
  .model("FeedStore")
  .props(FeedStoreProps)
  .extend(withEnvironment)
  .extend(withRootStore)
  .extend(withBaseModel)
  .views((self) => ({})) // eslint-disable-line @typescript-eslint/no-unused-vars
  .actions((self) => ({
    set(key: keyof typeof FeedStoreProps, value: any) {
      if (self[key] === value) return
      self[key] = value as never;
    },
    init() {
      self.initModel();
    },
    async store(data) {
      if (self.rootStore.appStore?.isOffline)
        return this.storeOffline(data)
      return self.storeModel(Feed, data, false, async (success: boolean, model: SyncableModel) => {
          await this.updateFasting(model, data)
        })
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile app: feed - add', data);
          return success;
        });
    },
    async storeOffline(data) {
      return self.storeModelOffline(Feed, data, async (success: boolean, model: SyncableModel) => {
          await this.updateFasting(model, data)
        })
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile app: feed - add', data);
          return success;
        });
    },
    async update(model: SyncableModel, data) {
      if (self.rootStore.appStore?.isOffline)
        return this.updateOffline(model, data)
      return self.updateModel(Feed, model, data, false, async (success: boolean, model: SyncableModel) => {
          await this.updateFasting(model, data)
        })
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile app: feed - edit', data);
          return success;
        });
    },
    async updateOffline(model: SyncableModel, data) {
      return self.updateModelOffline(Feed, model, data, async (success: boolean, model: SyncableModel) => {
          await this.updateFasting(model, data)
        })
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile app: feed - edit', data);
          return success;
        });
    },
    async delete(model: SyncableModel) {
      if (self.rootStore.appStore?.isOffline)
        return this.deleteOffline(model)
      return self.deleteModel(Feed, model, false)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile app: feed - delete', model.toArray());
          return success;
        });
    },
    async deleteOffline(model: SyncableModel) {
      return self.deleteModelOffline(Feed, model, false)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile app: feed - delete', model.toArray());
          return success;
        });
    },
    async updateFasting(feed: SyncableModel, feedData) {
      if (feedData.fasting == null) return;
      const { fastingStore } = self.rootStore
      const logged_date = moment.utc(feed.getAttribute('logged_at')).local().format('YYYY-MM-DD');
      const [fasting, ...restFastings] = await Fasting.fetch({
        cycle_id__eq: feed.getAttribute('cycle_id'),
        logged_date__eq: logged_date,
        sort: 'id'
      })
      if (!fasting)
        await fastingStore.store({
          cycle_id: feed.getAttribute('cycle_id'),
          logged_date,
          fasting: feedData.fasting || false,
        })
      else
        await fastingStore.update(fasting, {
          fasting: feedData.fasting || false
        })
      for (let i = 0; i < restFastings.length; i++) {
        await fastingStore.delete(restFastings[i]);
      }
    },
    async updateFastingOffline(feed: SyncableModel, feedData) {
      if (feedData.fasting == null) return;
      const { fastingStore } = self.rootStore
      const logged_date = moment.utc(feed.getAttribute('logged_at')).local().format('YYYY-MM-DD');
      const [fasting, ...restFastings] = await Fasting.fetch({
        cycle_id__eq: feed.getAttribute('cycle_id'),
        logged_date__eq: logged_date,
        sort: 'id'
      })
      if (!fasting)
        await fastingStore.storeOffline({
          cycle_id: feed.getAttribute('cycle_id'),
          logged_date,
          fasting: feedData.fasting || false,
        })
      else
        await fastingStore.updateOffline(fasting, {
          fasting: feedData.fasting || false
        })
      for (let i = 0; i < restFastings.length; i++) {
        await fastingStore.deleteOffline(restFastings[i]);
      }
    }
  })) // eslint-disable-line @typescript-eslint/no-unused-vars

type FeedStoreType = Instance<typeof FeedStoreModel>
export interface FeedStore extends FeedStoreType {}
type FeedStoreSnapshotType = SnapshotOut<typeof FeedStoreModel>
export interface FeedStoreSnapshot extends FeedStoreSnapshotType {}
export const createFeedStoreDefaultModel = () => types.optional(FeedStoreModel, {})
